var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserNavTogglerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.1905C22.7327 28.1905 28.1905 22.7327 28.1905 16C28.1905 9.26743 22.7327 3.80957 16 3.80957C9.26743 3.80957 3.80957 9.26743 3.80957 16C3.80957 22.7327 9.26743 28.1905 16 28.1905Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 17.5237C16.7618 17.5237 17.5237 16.7618 17.5237 15.9999C17.5237 15.238 16.7618 14.4761 15.9998 14.4761C15.2379 14.4761 14.4776 15.238 14.4776 15.9999C14.4776 16.7618 15.2379 17.5237 15.9998 17.5237ZM9.90461 17.5237C10.6665 17.5237 11.4284 16.7618 11.4284 15.9999C11.4284 15.238 10.6665 14.4761 9.90461 14.4761C9.14271 14.4761 8.38232 15.238 8.38232 15.9999C8.38232 16.7618 9.14271 17.5237 9.90461 17.5237ZM22.0951 17.5237C22.857 17.5237 23.6189 16.7618 23.6189 15.9999C23.6189 15.238 22.857 14.4761 22.0951 14.4761C21.3332 14.4761 20.5728 15.238 20.5728 15.9999C20.5728 16.7618 21.3332 17.5237 22.0951 17.5237Z",
    fill: "#1C1C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNavTogglerIcon);
export default __webpack_public_path__ + "static/media/user-nav-toggler-icon.fd6e5a70ec199ce4ad3379aec7484f17.svg";
export { ForwardRef as ReactComponent };